import axios from 'axios'

export default class Area {
  constructor (tokenBearer, url) {
    this.url = `${url}/api/dominios/tipoArea`
    this.tokenBearer = tokenBearer
  }

  getAreas () {
    return new Promise(async (resolve, reject) => {
      let optionsAreas = {
        method: 'get',
        url: `${this.url}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let responseAreas = await axios(optionsAreas)
        resolve(responseAreas)
      } catch (err) {
        reject(err)
      }
    })
  }
}
